import React from "react";
import { Link } from "react-router-dom";

const LeftMenu = ({ active }) => {
  return (
    <div className="healthSafetyEnvironmentWrapper">
      <div className="hseMenuLinks card">
        <Link
          className={`pointer${active === 1 ? " active" : ""}`}
          to={"/global-configuration/health-safety-and-environment/common"}
        >
          Common
        </Link>
        <Link
          className={`pointer${active === 2 ? " active" : ""}`}
          to={"/global-configuration/health-safety-and-environment/training"}
        >
          Training and Medical
        </Link>
        <Link
          className={`pointer${active === 3 ? " active" : ""}`}
          to={"/global-configuration/health-safety-and-environment/vfl"}
        >
          VFL
        </Link>
        {/* <Link className={`pointer${active === 2 ? " active" : ""}`} to={"/global-configuration/health-safety-and-environment/compliance-register"}>
                    Compliance Register
                </Link> */}
        <Link
          className={`pointer${active === 4 ? " active" : ""}`}
          to={"/global-configuration/health-safety-and-environment/manage-incidents"}
        >
          OHSE
        </Link>
        {/* <Link className={`pointer${active === 4 ? " active" : ""}`} to={"/global-configuration/health-safety-and-environment/work-permit-processes"}>
                    Approver Workflows
                </Link> */}
        <Link
          className={`pointer${active === 5 ? " active" : ""}`}
          to={"/global-configuration/health-safety-and-environment/sites"}
        >
          Locations
        </Link>
        {/* <Link className={`pointer${active === 6 ? " active" : ""}`} to={"/global-configuration/health-safety-and-environment/fire-alarm-points"}>
                    Fire Alarm Points
                </Link> */}
      </div>
    </div>
  );
};

export default LeftMenu;
